import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shell } from "@/components/Shell";
import { SummaryCards } from "@/components/SummaryCards";
import { TradeForm } from "@/components/TradeForm";
import { TickStrip } from "@/components/TickStrip";
import { BlockedBanner } from "@/components/BlockedBanner";
import { ProfileDrawer } from "@/components/ProfileDrawer";
import { useDesk } from "@/hooks/useDesk";

export default function Trade() {
  const desk = useDesk();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(false);
  const [symbol, setSymbol] = useState("");
  const [placed, setPlaced] = useState(0);

  useEffect(() => {
    desk.watch(symbol ? [symbol.toUpperCase()] : []);
  }, [symbol, desk.watch]);

  const onPlaced = (result) => {
    setSymbol("");
    setPlaced((p) => p + 1);
    desk.kick();
    navigate("/positions", { state: { highlight: result?.ticket ?? null } });
  };

  return (
    <Shell status={desk.status} onProfile={() => setProfile(true)}>
      <div className="flex flex-col gap-5">
        <div>
          <h1 className="text-2xl sm:text-3xl font-heading font-bold tracking-tight text-zinc-50">
            Trade
          </h1>
          <p className="text-xs text-zinc-300 font-mono mt-1">
            {desk.summary?.server_time_ist ? `${desk.summary.server_time_ist} IST` : "—"} · Balance $
            {desk.summary?.account?.balance?.toFixed(2) ?? "0.00"} · Equity $
            {desk.summary?.account?.equity?.toFixed(2) ?? "0.00"}
          </p>
        </div>

        <BlockedBanner blocked={desk.blocked} />
        <SummaryCards summary={desk.summary} collapsible mobileOnly />
        <TickStrip symbol={symbol} tick={desk.ticks?.[symbol?.toUpperCase()]} live={desk.live} />

        <div className="max-w-xl w-full">
          <TradeForm
            symbols={desk.symbols}
            settings={desk.settings}
            symbol={symbol}
            tick={desk.ticks?.[symbol?.toUpperCase()]}
            onSymbol={setSymbol}
            onPlaced={onPlaced}
          />
        </div>
      </div>

      <ProfileDrawer
        open={profile}
        onClose={() => setProfile(false)}
        status={desk.status}
        settings={desk.settings}
        summary={desk.summary}
        onChange={() => {
          desk.kick();
          desk.loadStatic();
        }}
      />
    </Shell>
  );
}
